import { render, staticRenderFns } from "./Form17CaseInformation.vue?vue&type=template&id=62f337a4&scoped=true"
import script from "./Form17CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form17CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f337a4",
  null
  
)

export default component.exports